import {
    ATTRIBUTES,
	SELECTORS
} from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { type BuildSetDrawer } from '@/scripts/product/build-set-drawer';

export class BuildSetToggle extends UcoastEl {
    static htmlSelector = 'build-set-toggle'
    button: HTMLButtonElement
    constructor() {
        super()

        this.button = q.rs('button', this)

        this.button.addEventListener('click', this.fetchBuildSet.bind(this))
    }

    async fetchBuildSet(e: Event) {
        e.preventDefault()
        const container = q.rs('.build-set-drawer__container', document)
        if(document.querySelector('build-set-drawer') || !container) return;


        this.button.setAttribute('aria-disabled', 'true')
		this.button.setAttribute(ATTRIBUTES.loading, '')
		q.rs(SELECTORS.loadingOverlaySpinner, this.button).classList.remove('hidden')

        const response = await fetch(`${this.dataset.handle}?section_id=build-set-drawer`, {
            credentials: 'same-origin',
            method: 'GET',
        })
        const responseText = await response.text()
        const responseDom = q.rs('build-set-drawer', new DOMParser().parseFromString(responseText, 'text/html'))
        container.innerHTML = responseDom.outerHTML
        const buildSetDrawer = q.rs<BuildSetDrawer>('build-set-drawer', document)
        buildSetDrawer.open()

        this.button.removeAttribute('aria-disabled')
        this.button.removeAttribute(ATTRIBUTES.loading)
        q.rs(SELECTORS.loadingOverlaySpinner, this.button).classList.add('hidden')
    }
}